import { useTranslation } from 'react-i18next'

import { CalendarBlankIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Select } from '@reveni-io/reveni-ui'

import DateRangePickerOption from './DateRangePickerOption/DateRangePickerOption'
import useDateRange from './hooks/useDateRange'
import { timeRangeOptions } from './constants'
import { formatDate, isCustomDateRangeValid } from './helpers'

const TimeRangeSelect = ({ onChange, value, onChangeRanges, rangeValue }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { startDate, endDate, inputValues, onChangeDate, handleChangeInputDate, resetDateRange } =
    useDateRange(rangeValue)

  const onSaveRange = () => {
    onChangeRanges({ startDate, endDate })
  }

  const getCustomOptionText = () => {
    if (startDate && endDate) {
      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    }
    return t('Rango de fechas')
  }

  return (
    <Select
      icon={<CalendarBlankIcon size={16} />}
      backgroundColor={theme.colors.background.secondary}
      onChange={onChange}
      value={value}
      options={timeRangeOptions.map(o => ({ ...o, label: t(o.label) }))}
      showCustomOption
      customOptionText={getCustomOptionText()}
      customElement={
        <DateRangePickerOption
          startDate={startDate}
          endDate={endDate}
          onChangeDate={onChangeDate}
          inputValues={inputValues}
          handleChangeInputDate={handleChangeInputDate}
        />
      }
      onSaveCustomOption={onSaveRange}
      onCloseCustomOption={resetDateRange}
      disabledOnSaveCustomOption={!isCustomDateRangeValid(inputValues.startDate, inputValues.endDate)}
    />
  )
}

export default TimeRangeSelect
